import { _checkAuth } from '@sanity/preview-kit';
import { SANITY_PROJECT_ID } from 'config/sanity-env';
import { suspend } from 'suspend-react';

const useCheckAuth = (): boolean =>
  suspend(
    async () => _checkAuth(SANITY_PROJECT_ID, null),
    ['@sanity/preview-kit', 'checkAuth', SANITY_PROJECT_ID],
  );

export default useCheckAuth;
